export default ($settings) => Object.assign({
  routes: {}
}, $settings)